module.exports = __webpack_public_path__ + "img/sgRNAInfo.d3e60e60.png";